import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "main",
  class: "qaP"
}
const _hoisted_2 = { class: "sec-main qaP-main bg-gray" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row head-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-11 col-sm-10 mx-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h2 text-primary mb-4" }, "創業Q&A")
  ])
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-xl-1 d-none d-xl-flex" }, null, -1)
const _hoisted_13 = { class: "col-11 col-sm-10 col-xl-9 mx-xl-0 mx-auto" }
const _hoisted_14 = { class: "h3 qa-title mb-md-4 mb-3" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-11 col-sm-10 mx-auto" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "frce mt-4" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "javascript:void(history.go(-1))",
        class: "btn-anchor back",
        aria: "返回前頁"
      }, [
        /*#__PURE__*/_createElementVNode("span", null, "返回前頁")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/qa",
                  title: "創業工具",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("創業工具 - 創業Q&A")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.item.title), 1)
            ])
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.item.title), 1),
            _createElementVNode("div", {
              class: "editor-content",
              innerHTML: _ctx.sanitizeHtml(_ctx.item.content)
            }, null, 8, _hoisted_15)
          ])
        ]),
        _hoisted_16
      ])
    ])
  ]))
}